import(/* webpackMode: "eager", webpackExports: ["PublicIntelShell"] */ "/vercel/path0/web/components/max/PublicIntelShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Section"] */ "/vercel/path0/web/components/max/ui.tsx");
